import {
  ComponentProps,
  ComponentType,
  ReactNode, useEffect, useRef,
} from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import {
  Flex,
  FlexColumn,
  FlexGrowCss,
} from '../Flex';
import { Footer, SmallFooterContainer, SmallFooterWrapper } from '../Footer';
import { mobileCss, useStyledTheme } from '../../styling';
import { Sidebar } from '../Sidebar';
import { useCreateAndAddRefs } from '..';

const PageContainer = styled(Flex)`
  height: 100vh;
  overflow-x: hidden;
  max-width: 100vw;
`;

const MainContentContainer = styled(FlexColumn)`${() => `
  ${FlexGrowCss};
  box-sizing:border-box;
  z-index:9;
`}`;

const ContentContainer = styled(FlexColumn)`
  ${FlexGrowCss};
  min-width: 0;
`;

const MidContentContainer = styled(FlexColumn)`
  ${FlexGrowCss};
`;

export const InnerContentContainerDefault = styled(Flex)`${({ theme }) => `
  ${FlexGrowCss};
  padding: ${theme.padding[4]} ${theme.padding[7]};
  box-sizing:border-box;
  height:100%;
  ${mobileCss(`
      padding-left:0;
      padding-right:0;
  `)};
`}`;

const SidebarContainer = styled.div`${() => `
  position:sticky;
  top:0;
  height: 100%;
  width:auto;
  margin-bottom:0;
`}`;

export const PageRefName = 'page';

export function Page({
  header,
  subHeader,
  InnerContentContainer = InnerContentContainerDefault,
  sidebar,
  sidebarFooter,
  children,
}: {
  header: ReactNode,
  subHeader?: ReactNode,
  InnerContentContainer?: ComponentType<ComponentProps<'div'>>,
  sidebar?: ReactNode,
  sidebarFooter?: ReactNode,
  children: ReactNode
}) {
  const { pathname, hash } = useLocation();
  const theme = useStyledTheme();

  useEffect(() => {
    if (hash === '') {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash]);

  const fieldRef = useRef<HTMLDivElement>(null);

  const pageRef = useCreateAndAddRefs(PageRefName);

  // RENDER
  return (
    <PageContainer ref={pageRef}>
      {sidebar && (
        <SidebarContainer id="sidebar-container">
          <Sidebar sidebar={sidebar} sidebarFooter={sidebarFooter} width={theme.sidebarWidth} />
        </SidebarContainer>
      )}

      <ContentContainer>
        <MainContentContainer>
          {header}
          {subHeader}
          <MidContentContainer id="MidContentContainer" ref={fieldRef}>
            <InnerContentContainer id="InnerContentContainer">
              {children}
            </InnerContentContainer>
            {sidebar && (
              <Footer />
            )}
          </MidContentContainer>
        </MainContentContainer>

        {!sidebar && (
          <SmallFooterWrapper>
            <SmallFooterContainer>
              <Footer />
            </SmallFooterContainer>
          </SmallFooterWrapper>
        )}
      </ContentContainer>
    </PageContainer>
  );
}
